import offeringSummary from './offering-summary';
import {buildIncomeAndExpenses} from './income-and-expenses';
import expenses from './expenses';
import rentRollHeader from './rent-roll-header';
import {rentRoll} from './rent-roll';
import {summedRentRoll} from './sumed-rent-roll';
import reimbursementsHeader from './reimbursements-header';
import {reimbursements} from "./reimbursements";
import {summedReimbursements} from "./sumed-reimbursements";

export default {
    name: 'Marketing',
    tables: {
        'offering-summary': offeringSummary,
        'income-and-expenses': buildIncomeAndExpenses(false),
        'proforma-income-and-expenses': buildIncomeAndExpenses(true),
        'expenses': expenses,
        'rent-roll-header': rentRollHeader,
        'rent-roll': rentRoll,
        'sumed-rent-roll': summedRentRoll,
        'reimbursements-header': reimbursementsHeader,
        'reimbursements': reimbursements,
        'sumed-reimbursements': summedReimbursements,
    }
};